module.exports = __webpack_public_path__ + "static/Especialistas_ReduceRiskOfLOC-20925d8321c3b730f0b1c331f239a464.png";